import { render, staticRenderFns } from "./AppSplashScreen.vue?vue&type=template&id=7305117a"
import script from "./AppSplashScreen.vue?vue&type=script&lang=js"
export * from "./AppSplashScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports